<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="700"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="欢迎语类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'chatType',
              {
                rules: [{ required: true, message: '请选择欢迎语类型' }]
              }
            ]"
            placeholder="请选择欢迎语类型"
            :getPopupContainer="target => target.parentNode"
          >
            <a-select-option value="1">个人欢迎语</a-select-option>
            <a-select-option value="2">渠道欢迎语</a-select-option>
            <a-select-option value="3">群聊欢迎语</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="欢迎语内容"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :rows="4"
            placeholder="请添加文字欢迎语"
            v-decorator="[
              'textContent',
              {
                rules: [
                  {
                    required: value === 4 ? true : false,
                    message: '请输入欢迎语内容'
                  }
                ]
              }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="欢迎语素材"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group
            name="radioGroup"
            v-model="value"
            :default-value="1"
            @change="radioChange"
          >
            <a-radio :value="4"> 无 </a-radio>
            <a-radio :value="1"> 图片 </a-radio>
            <a-radio :value="2"> 链接 </a-radio>
            <a-radio :value="3"> 小程序 </a-radio>
          </a-radio-group>
        </a-form-item>
        <div style="margin-top: 20px">
          <a-form-item
            v-if="this.value == 2"
            label="链接地址"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              placeholder="请输入链接地址,以http://或https://开头"
              v-decorator="[
                'linkUrl',
                { rules: [{ required: true, message: '请输入链接地址' }] }
              ]"
            />
            <!-- { required: true, message: '请输入链接地址!' } -->
          </a-form-item>
          <a-form-item
            v-if="this.value == 2"
            label="图文标题"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              placeholder="请输入图文标题"
              v-decorator="[
                'linkTitle',
                { rules: [{ required: true, message: '请输入图文标题!' }] }
              ]"
            />
            <!-- { required: true, message: '请输入图文标题!' } -->
          </a-form-item>
          <a-form-item
            v-if="this.value == 3"
            label="appid"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              placeholder="请输入appid"
              v-decorator="[
                'miniprogramAppid',
                { rules: [{ required: true, message: '请输入appid!' }] }
              ]"
            />
          </a-form-item>
          <a-form-item
            v-if="this.value == 3"
            label="消息标题"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              placeholder="请输入小程序消息标题"
              v-decorator="[
                'miniprogramTitle',
                { rules: [{ required: true, message: '请输入消息标题!' }] }
              ]"
            />
          </a-form-item>
          <a-form-item
            v-if="this.value != 4"
            :label="
              this.value == 1
                ? '图片'
                : this.value == 2
                ? '图片封面'
                : '消息封面'
            "
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <UploadImage
              :accept="'.jpg, .png'"
              @handleFileList="getFileList"
              v-decorator="[
                this.value == 1
                  ? 'imagePicUrl'
                  : this.value == 2
                  ? 'linkPicurl'
                  : 'miniprogramPicMediaId',
                {
                  rules: [
                    {
                      required: this.value == 1 ? true : false,
                      message: '请输入上1111传图片'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item
            v-if="this.value == 3"
            label="页面路径"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              placeholder="请输入页面路径"
              v-decorator="[
                'miniprogramPage',
                { rules: [{ required: true, message: '请输入页面路径!' }] }
              ]"
            />
          </a-form-item>
        </div>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit()" type="primary" :loading="confirmLoading"
        >提交审核</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import moment from 'moment';
import { postTag } from '@/api/manage';
import UploadImage from '@/components/common/UploadImage';
export default {
  name: 'TextingMoadl',
  components: {
    UploadImage
  },
  data() {
    return {
      id: '',
      edit: false,
      title: '操作',
      visible: false,
      value: 4,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      url: {
        fileUpload: 'wechatwork-groupchat-biz/wechatwork/wechatMsg/upMaterial',
        upMaterialInfo:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/welcome/addWelcomeInfo',
        editMaterial:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/welcome/editWelcomeInfo'
      },
      avatarUrl: '', //图片地址
      avatar_mediaid: '', //图片的id
      fileList: {}
    };
  },
  computed: {
    uploadAction: function() {
      return this.url.fileUpload;
    }
  },
  methods: {
    add(record) {
      this.form.resetFields();
      let records = { ...record };
      this.model = Object.assign({}, records);

      if (record != undefined) {
        this.edit = true;
        this.id = record.id;
        if (record.linkTitle) {
          this.value = 2;
          this.$nextTick(() => {
            setTimeout(() => {
              this.form.setFieldsValue(
                pick(
                  this.model,
                  'chatType',
                  'textContent',
                  'linkUrl',
                  'linkTitle',
                  'linkPicurl',
                  'linkDesc',
                  'miniprogramTitle',
                  'miniprogramAppid',
                  'miniprogramPage'
                )
              );
              this.form.setFieldsValue({
                miniprogramPicMediaId: this.model.programUrl
              });
            });
          }, 1000);
        } else if (
          record.miniprogramAppid ||
          record.miniprogramPage ||
          record.miniprogramPicMediaId ||
          record.miniprogramTitle
        ) {
          this.value = 3;

          this.$nextTick(() => {
            setTimeout(() => {
              this.form.setFieldsValue(
                pick(
                  this.model,
                  'chatType',
                  'textContent',
                  'linkUrl',
                  'linkTitle',
                  'linkPicurl',
                  'linkDesc',
                  'miniprogramTitle',
                  'miniprogramAppid',
                  'miniprogramPage'
                )
              );
              this.form.setFieldsValue({
                miniprogramPicMediaId: this.model.programUrl
              });
            });
          }, 1000);
        } else {
          if (record.imagePicUrl) {
            this.value = 1;
          } else {
            this.value = 4;
          }

          // if(record.chatType)
          this.$nextTick(() => {
            setTimeout(() => {
              this.form.setFieldsValue(
                pick(this.model, 'chatType', 'textContent', 'imagePicUrl')
              );
            });
          }, 1000);
        }
      }
      this.visible = true;
    },
    close() {
      this.$emit('close');
      this.form.resetFields();
      this.value = 4;
      this.visible = false;
    },
    moment,
    handleSubmit() {
      console.log(this.fileList, 'this.fileList');
      // 触发表单验证
      this.form.validateFields((err, values) => {
        console.log(values, 222);
        if (!err) {
          if (this.edit) {
            if (this.value == 1) {
              postTag(this.url.editMaterial, {
                chatType: values.chatType,
                textContent: values.textContent,
                imagePicUrl: this.fileList.fileName,
                id: this.id
              }).then(res => {
                if (res.success) {
                  this.$emit('ok');
                  this.close();
                }
              });
            } else {
              let param = {
                chatType: values.chatType,
                textContent: values.textContent,
                linkTitle: values.linkTitle,
                linkPicurl: this.fileList.fileName,
                linkDesc: values.linkDesc,
                linkUrl: values.linkUrl,
                miniprogramTitle: values.miniprogramTitle,
                miniprogramPicMediaId: values.miniprogramPicMediaId,
                miniprogramAppid: values.miniprogramAppid,
                miniprogramPage: values.miniprogramPage,
                id: this.id
              };
              if (this.value == 3) {
                param.programUrl = this.avatarUrl;
                param.miniprogramPicMediaId = this.avatar_mediaid;
              }
              postTag(this.url.editMaterial, param).then(res => {
                if (res.success) {
                  this.$emit('ok');
                  this.close();
                }
              });
            }
          } else {
            if (this.value == 1) {
              postTag(this.url.upMaterialInfo, {
                chatType: values.chatType,
                textContent: values.textContent,
                imagePicUrl: this.fileList.fileName
              }).then(res => {
                if (res.success) {
                  this.$emit('ok');
                  this.close();
                }
              });
            } else {
              let param = {
                chatType: values.chatType,
                textContent: values.textContent,
                linkTitle: values.linkTitle,
                linkPicurl: this.fileList.fileName,
                linkDesc: values.linkDesc,
                linkUrl: values.linkUrl,
                miniprogramTitle: values.miniprogramTitle,
                miniprogramPicMediaId: values.miniprogramPicMediaId,
                miniprogramAppid: values.miniprogramAppid,
                miniprogramPage: values.miniprogramPage
              };
              if (this.value == 3) {
                param.programUrl = this.avatarUrl;
                param.miniprogramPicMediaId = this.avatar_mediaid;
              }
              postTag(this.url.upMaterialInfo, param).then(res => {
                console.log(res);
                if (res.success) {
                  this.$emit('ok');
                  this.close();
                }
              });
            }
          }
        }
      });
    },

    handleCancel() {
      this.close();
    },
    radioChange() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.value == 1) {
            this.form.setFieldsValue(
              pick(this.model, 'chatType', 'textContent', 'imagePicUrl')
            );
          } else if (this.value == 2 || this.value == 3) {
            this.form.setFieldsValue(
              pick(
                this.model,
                'chatType',
                'textContent',
                'linkUrl',
                'linkTitle',
                'linkPicurl',
                'linkDesc',
                'miniprogramTitle',
                'miniprogramPicMediaId',
                'miniprogramAppid',
                'miniprogramPage'
              )
            );
          }
        });
      }, 1000);
    },
    getFileList(file) {
      this.fileList = file;
      let str =
        this.value == 1
          ? 'imagePicUrl'
          : this.value == 2
          ? 'linkPicurl'
          : 'miniprogramPicMediaId';

      this.form.setFieldsValue({
        [str]: process.env.VUE_APP_FILE_PATH + file.fileName
      });
      console.log(this.form.getFieldsValue());
    }
  }
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}

.ant-form-item {
  margin-bottom: 20px;
}
</style>
